// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FormatPainterFilledSvg from "@fishx/icons-svg/es/asn/FormatPainterFilled";
import FishxIcon from '../components/FishxIcon';

var FormatPainterFilled = function FormatPainterFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FormatPainterFilledSvg
  }));
};

FormatPainterFilled.displayName = 'FormatPainterFilled';
export default React.forwardRef(FormatPainterFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FormatPainterFilled.js
// module id = 2826
// module chunks = 0